import React from 'react';
import CodeGenarator from './../CodeComponent/codeGenerator';
import themes from '../../Values/themes';
import ThemesComponent from './themesComponent';
import CopyClip from './copyClip';

// for (let index = 0; index < themes.length; index++) {
//     const theme = themes[index];
//     $('.them-kepper').append(`<div class="theme" data-theme="${index}"><div>theme${index}</div><div>`)
//     // console.log(theme.drawerInsideStyle["background"])
    // $(`.theme[data-theme="${index}"]`).css({
    //   "background": theme.drawerInsideStyle["background"],
    //   "color": theme.textStyle["color"]
    // })
    // $(`.theme[data-theme="${index}"] div`).hover(function () {
    //   $(this).css({
    //     "padding": "10px",
    //     "border-radius": "2px",
    //     "background": theme.drawerItemHoverEnterStyle["background"]
    //   })
    // }, function () {
    //   $(this).css({
    //     "background": theme.drawerItemHoverExitStyle["background"]
    //   })
//     })
//   }
//   $(".theme").on('click', function () {
//     let themeData = $(this).data("theme");
//     // console.log(themeData)
//     LessCode.drawer({
//       exitResizeing: false,
//       customJqueryElement: $(".nav .nav-item").clone(true),
//       customHeadDrawer: `<div>Drawer</div>`,
//       class: {
//         showButton: "theme[data-theme='" + themeData + "']"
//       },
//       defualtStylesPosition: themeData
//     })
//     LessCode.drawerShow()
//   })

export default class Main4Component extends React.Component{
    constructor(props){
        super(props);
        this.state={themes:themes}
    }

    render(){
        let themesa=this.state.themes.map((v,ind)=>{
            // let colorT=v.textStyle["color"]
            return <ThemesComponent 
            key={ind}
            index={ind}
            mainStyle={{
                "background": v.drawerInsideStyle["background"],
                    "color": v.textStyle["color"]
            }}
            leave={{
                "background": v.drawerItemHoverExitStyle["background"]
              }} 
            enter={{
                "padding": "10px",
                "borderRadius": "2px",
                "background": v.drawerItemHoverEnterStyle["background"]
              }}
            />
        })
        let stringCode3 = `
$(document).ready(function() {
  LessCode.drawer({
     defualtStylesPosition:0
   })
});`
        return(
            <div className="main bg-light" data-nav="4">
                    <h3 id="themes-themes">Themes</h3>
                    <p>Defined themes that can be used for clothing. click on the theme you want, the drawer will open with that theme.</p>
                    <div className="container">
                        <div className="row them-kepper">
                            {themesa}
                        </div>
                    </div><br/><br/><br/>
                    <h5 id="usage-themes">usage</h5>
                    <p>Substitute your theme number with 0.</p>
                    <div className="container">
                        <div className="row ">
                            <div className="col-12 col-code-keeper position-relative">
                                <div className="clipbord-keeper1">
                                    {/* <svg className="clipbord-svg" data-codes="3" id="i-clipboard"
                                    title="" data-original-title="Copy to clipboard"  
                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20" height="20"
                                        fill="none" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round"
                                        strokeWidth="2">
                                        <path d="M12 2 L12 6 20 6 20 2 12 2 Z M11 4 L6 4 6 30 26 30 26 4 21 4" />
                                    </svg>
                                    <textarea className="clipbordArea" data-codes="3" cols="auto" rows="auto"></textarea> */}
                                <CopyClip value={stringCode3}></CopyClip>
                                </div>
                                <div className="code-keeper">
                                <CodeGenarator code={stringCode3}></CodeGenarator>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
        )
    }
    

}